const { VUE_APP_OPEN_ACCOUNT } = process.env
import { get, post, path_version } from '@/httpRequest/http.js'
import { getBaseUrl } from '@/utils'
import { ENCRYPT_TYPES } from '../../httpRequest/http'

const baseUrl = getBaseUrl(VUE_APP_OPEN_ACCOUNT)

// 查询用户开户的信息
export const ApplyDetail = () => {
    return get(baseUrl + '/kyc/v1/ApplyDetail')
}

// 当用户未开户准备第一次开户时调用该接口，如果用户是在开户中或者开户成功调用接口返回用户开户状态错误。
export const ApplyStart = data => {
    return post(baseUrl + '/kyc/v1/ApplyStart', {
        data,
    })
}

/**
 * @param {个人开户简体 (zhCn + 非期权账户): type = 1
 * @param {个人开户繁体 (zhTc + 非期权账户): type = 13
 * @param {个人开户+期权账户简体 (zhCn + 期权账户): type = 14
 * @param {个人开户+期权账户繁体 (zhTc + 期权账户): type = 15
 */
export const ApplyDisclosureInfo = (params = {}) => {
    return get(baseUrl + '/kyc/v1/ApplyDisclosureInfo', {
        params,
    })
}

export const ApplyDocument = option => {
    return get(baseUrl + '/kyc/v1/ApplyDocument', {
        params: option,
    })
}

/** 获取国内的省市区 */
export const MainlandCity = (data = {}) => {
    return get(baseUrl + `/kyc/${path_version}/MainlandCity?`, {
        params: data,
    })
}

/** 用户能否开户校验 */
export const ApplyCheck = data => {
    return post(baseUrl + '/kyc/v1/ApplyCheck', {
        data,
    })
}
/**
 * @openingLimitType 限制开户 1 无限制 2 限制内地 IP 3 限制内地 4 仅不支持境内地理位置开户 5 不支持境内IP或境内地理位置开户
 * @isInternalIP IP 白名单，为 true 时跳过签署校验
 * @statementLimitType 结单开关 1打开  !1关闭
 * @statementSkipType 结单跳过开关（结单开关未打开时没有该字段） 1开启 2关闭
 * */
export const AccountOpeningAreaType = () =>
    get(`${baseUrl}/kyc/v1/AccountOpeningAreaType`)
        .then(({ data }) => {
            if (data?.result?.openingLimitType) {
                localStorage.setItem('areaTypeFlag', data.result.openingLimitType)
            }
            if (data?.result?.statementLimitType) {
                localStorage.setItem('statementLimitType', data.result.statementLimitType)
            }
            if (data?.result?.statementSkipType) {
                localStorage.setItem('statementSkipType', data.result.statementSkipType || 2)
            }
            return { data }
        })
        .finally(() => {
            localStorage.setItem('position', '')
        })

/** 定位服务 */
export const PostionInfo = location => post(`${baseUrl}/kyc/v1/PostionInfo`, { data: { location } })

export const agreementSignStatus = (params) => {
  return get(`${baseUrl}/agreement/v1/SignStatus`, { params })
}

export const agreementSign = (params) => {
  return post(`${baseUrl}/agreement/v1/Sign`, {
    data: params,
    encrypt: ENCRYPT_TYPES.LOGIN,
  })
}